import styled from 'styled-components';

interface PopUpProps {
    popUpAttendence?: boolean;
    status?: string;
}

interface ContainerProps {
    tab: string
}

export const Container = styled.div<ContainerProps>`
    display: flex;
    transform: ${(props) => props.tab === 'chat' ? 'translate(0%, 0px);' : 'translate(-100%, 0px);'}
    transition: all .5s;
    > div {
        width: 100%;
        min-width: 100%;
    }
    .input {
        input {
            color: #5A646E;
        }
    }
`;

export const ContentUsers = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 24px 24px 24px;
    height: 100%;
    max-height: calc(600px - 76px);
    box-sizing: border-box;
    overflow: auto;
    h2 {
        color: #8A99A8;
        font-size: 14px;
        font-weight: normal;
    }
`;

export const CardPerson = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const PersonImage = styled.div`
    display: grid;
    place-items: center;
    width: 40px;
    height: 40px;
    border-radius: 100px;
    border: 1px solid #ffffff;
    background: #CCC;
    background-size: cover;
`;

export const PersonInfo = styled.div<PopUpProps>`
    display: flex;
    flex-direction: column;
    margin-left: 16px;

    p {
        font-size: 14px;
        color: #5A646E;
        display: flex;
        align-items: center;
        font-weight: normal;

        .ball {
            width: 8px;
            height: 8px;
            margin-left: 4px;
            background: ${(props) =>
                props.status === 'Em atendimentos'
                    ? '#38FFE7'
                    : '#fff' && props.status === 'Pausa'
                    ? '#CB3D9A'
                    : '#fff' && props.status === 'Aguardando fila'
                    ? '#F5A623'
                    : '#fff' && props.status === 'Operadores Online'
                    ? '#7B61FF'
                    : '#fff' && props.status === 'Abandono'
                    ? '#FF868B'
                    : '#fff'};
            border-radius: 50%;
        }
    }
`;


//aba
export const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`
export const ChatContainer = styled.div`
    display: flex;
    flex-direction: column;
`

export const ListAttendence = styled.div`
    display: flex;
    flex-direction: column;
    gap: 22px;
    margin-top: 16px;

    h3 {
        color: #5A646E;
        font-weight: normal;
    }
`;